import React from 'react';
import { Range, Handle } from 'rc-slider';
import { getThousandSeperatedNumber } from '../../../common/app/helperFunctions';
import './styles.css';
import 'rc-slider/assets/index.css';

const handle = (props, minPrice, maxPrice) => {
  const { className, value, offset, index } = props;
  const left = className[className.length - 1] === '1';
  const diff = maxPrice - minPrice;
  return (
    <div key={index}>
      <Handle {...props} />
      <div
        className={`label ${left ? 'left' : 'right'}`}
        style={{
          left: diff > 60000 ? `calc(-50px + ${(offset)}%)` : left ? `calc(-95px + ${(offset)}%)` : `${offset - 2}%`,
          textAlign: (left && diff <= 60000) ? 'right' : (!left && diff <= 60000) ? 'left' : '',
        }}
      >
        {getThousandSeperatedNumber(value)} <span>kr</span>
      </div>
    </div>
  );
};

handle.propTypes = {
  className: React.PropTypes.any,
  value: React.PropTypes.any,
  offset: React.PropTypes.any,
  index: React.PropTypes.any,
};

const PriceFilter = ({ minPrice, maxPrice, onMinMaxPriceChange }) => (
  <div className="interval-filter">
    <h2>Verð</h2>
    <div className="slider-wrapper">
      <Range
        min={0}
        max={250000}
        step={10000}
        allowCross={false}
        value={[minPrice, maxPrice]}
        onChange={onMinMaxPriceChange}
        handle={props => handle(props, minPrice, maxPrice)}
      />
    </div>
    <div className="min-max-label">
      <span>0 kr.</span>
      <span>250.000 kr. +</span>
    </div>
  </div>
);

PriceFilter.propTypes = {
  onMinMaxPriceChange: React.PropTypes.func.isRequired,
  minPrice: React.PropTypes.number.isRequired,
  maxPrice: React.PropTypes.number.isRequired,
};

export default PriceFilter;



// WEBPACK FOOTER //
// ./src/browser/filters/PriceFilter/PriceFilter.js